import { Component, OnInit, NgZone, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormdataService } from '@services/formdata.service';
import { SaveService } from '@services/save.service';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import * as _ from 'lodash';
import { CategoryService } from '@services/category.service';
import { CATEGORYEDIT } from '@category/sra_category_edit';
import { Helper } from '@category/helper';
@Component({
  selector: 'app-cpoll',
  templateUrl: './cpoll.component.html',
  styleUrls: ['./cpoll.component.sass']
})
export class CpollComponent implements OnInit {

  
  error: any = {  };
  component = "";
  application = "";
  btn_process = false;
  appCreateForm: FormGroup;
  selected_category = "";
  timezone_list:any=[];
  status_list: any = [];
  constructor(private _categoryService: CategoryService, private fb: FormBuilder, private _saveService: SaveService, private _formdataService: FormdataService, private route: ActivatedRoute, private _global: GlobalService, private router: Router) {
    this.component = this._global.COMPONENTS_SMN;
    this.application = "poll";
    this.appCreateForm = this.fb.group({
      name: [],
      timeZone:[],
      description: [],
      status:[],
      startTime:[],
      endTime:[]
    });
    let THIS = this;
    let p = {
      'component': this.component,
      'application': 'category',
      'categoryType': this.application
    };
    this._categoryService.application(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          let result = this._global.getVal(data, 'response', '');
          CATEGORYEDIT.init(result, '#' + this.application + '_category', true, "categoryTree", '', this.application, true);
          $("div#" + this.application + "_category").click(function (e) {
            var $target = $(e.target);
            if ($target.attr("id") === "categoryCheck") {
              THIS.selected_category = Helper.categoryJsonText("categoryCheck");
            }
          });
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
      let f = {
        'component': this.component,
        'application': this.application
      };
      this._formdataService.common(f, 'time').subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.timezone_list = this._global.getVal(data, 'response.timeZone', '');
          }
        },
        error => {
          console.log("error", JSON.stringify(error));
        });
        this._formdataService.common(f, 'listStatusTypes').subscribe(
          data => {
            if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
              this.status_list = this._global.getVal(data, 'response', '');
            }
          },
          error => {
            console.log("error", JSON.stringify(error));
          });
   
  }

  ngOnInit() {
  }
  save() {
    this.error = {  };
    this.btn_process = true;
    let r = this.appCreateForm.value;
    r.component = this.component;
    r.application = this.application;
    let p = this._global.paramsRemoveNull(r);
    p.categoryJson = Helper.getCategoryChecboxValues("categoryCheck", '');
    if (p.startTime) {
      p.startTime = new Date(p.startTime).getTime();
    }
    if (p.endTime) {
      p.endTime = new Date(p.endTime).getTime();
    }
    this._saveService.app(p).subscribe(
      data => {

        let severity = 'success';
        let message = '';
        if (this._global.getVal(data, 'status', '') == 1) {
          message = this._global.getVal(data, 'message.info', '');
          this._global.showMessage({ type: severity, message: message });
          this.router.navigate(['/my/' + this.application]);
        } else {
          this.btn_process = false;
          message = this._global.getVal(data, 'message.error', '');
          severity = 'warning';
          for (let key in data["errors"]) {
            this.error[key] = this._global.getVal(data, 'errors.' + key + '.message', '');
          }
          this._global.showMessage({ type: severity, message: message });
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
}
